// extracted by mini-css-extract-plugin
module.exports = {"container":"footer-module--container--3aTkc","copyright":"footer-module--copyright--3Bb4w"};